import clsx from "clsx";
import type { FC, ReactNode } from "react";
import { createPortal } from "react-dom";
import css from "./FloatingActionBar.module.css";

export interface FloatingActionBarProps {
  active?: boolean;
  className?: string;
  children?: ReactNode;
}

/**
 * A floating action bar that can be used to display actions or controls. Slides into view when active,
 * slides out when inactive.
 */
export const FloatingActionBar: FC<FloatingActionBarProps> = ({ active, className, children }) =>
  createPortal(
    <div className={css.fullscreenContainer}>
      <div className={clsx(css.floatingActionBar, className, active && css.active)} {...(!active && { inert: "" })}>
        {children}
      </div>
    </div>,
    document.body,
  );
